import { version } from '../../package.json';

export const environment = {
  production: true,
  mock: false,
  tracking: true,
  appVersion: version
};
